import { Flex, Text } from '@revenuemarket/cds';
import CheckLine from '@revenuemarket/cds/components/Icon/CheckLine';
import { Colors } from '@revenuemarket/design';

interface Props {
  onSelectAll: () => void;
  onClearAllSelect: () => void;
  hasSelectedItems: boolean;
  selectAllText?: string;
  clearAllText?: string;
}

const SearchSelectAllActions: React.FC<Props> = ({
  onSelectAll,
  onClearAllSelect,
  hasSelectedItems,
  selectAllText = '검색 결과 모두 선택',
  clearAllText = '선택해제',
}) => {
  return (
    <Flex align="center" gap={8}>
      <Flex
        align="center"
        gap={2}
        style={{
          backgroundColor: Colors.grayOpacity04,
          padding: '3px 6px',
          borderRadius: '7px',
          cursor: 'pointer',
        }}
        onClick={onSelectAll}
      >
        <CheckLine width={16} height={16} fill={'#4C5053'} />
        <Text textStyle="13_500">{selectAllText}</Text>
      </Flex>

      {hasSelectedItems && (
        <Text
          textStyle="13_500"
          style={{
            backgroundColor: Colors.grayOpacity04,
            padding: '3px 6px',
            borderRadius: '7px',
            cursor: 'pointer',
          }}
          onClick={onClearAllSelect}
        >
          {clearAllText}
        </Text>
      )}
    </Flex>
  );
};

export default SearchSelectAllActions;
